const badges = {
  credited:          { label: 'Credited',         className: 'credited'           },
  pending:           { label: 'Pending',           className: 'pending'            },
  online:            { label: 'Online',            className: 'server-online'      },
  offline:           { label: 'Offline',           className: 'server-offline'     },
  paid_out:          { label: 'Paid Out',          className: 'status-paid-out'    },
  payout_rejected:   { label: 'Rejected',          className: 'status-rejected'    },
  creator_disabled:  { label: 'Creator Disabled',  className: 'status-disabled'    },
};

function StatusBadge({ status }) {
  const { label, className } = badges[status] ?? { label: status, className: '' };
  return <span className={className}>{label}</span>;
}

export { StatusBadge };
